export default __webpack_public_path__ + "static/media/flow.3f472f27.cdz";